function timeOfDay(value, longFormat) {
  if (value) {
    const parts = value.split(':');
    const hours24 = Number(parts[0]);
    let hours12 = hours24 > 12 ? hours24 - 12 : hours24;
    const daypart = hours24 < 12 ? 'AM' : 'PM';
    const minutes = parts[1];

    if (hours12 === 0) {
      hours12 = 12;
    }

    if (longFormat) {
      return `${hours12}:${minutes} ${daypart}`;
    }

    if (minutes === '00') {
      return `${hours12}:${minutes} ${daypart}`;
    }

    return `${hours12}:${minutes} ${daypart}`;
  }

  return null;
}



export default timeOfDay;
